import React from 'react';
import { Lock } from 'lucide-react';
import { OfferSection } from './OfferSection';
export function FinalOfferSection() {
  return <section className="py-16 px-4 bg-[#F0F4EC] border-t border-[#E8DFD0] relative overflow-hidden" data-id="element-266">
      {/* Glow effect */}
      <div className="absolute bottom-0 left-0 w-full h-[300px] bg-[#2D5A3D] opacity-[0.05] blur-[80px] pointer-events-none" data-id="element-267"></div>

      <div className="max-w-[600px] mx-auto relative z-10" data-id="element-268">
        <div className="space-y-8 mb-12 text-left text-[#5C4A3A]" data-id="element-269">
          {/* Dos Caminos */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-270">
            <div className="bg-[#FEF2F2] border border-[#FECACA] rounded-xl p-5" data-id="element-271">
              <p className="font-bold text-[#B91C1C] text-sm uppercase tracking-wide mb-3" data-id="element-272">
                El Camino A
              </p>
              <p className="text-[#5C4A3A] text-sm leading-relaxed" data-id="element-273">
                Cierras esta página. Vuelves al botiquín de siempre. Sigues
                esperando que algo cambie haciendo exactamente lo mismo que has
                hecho hasta ahora.
              </p>
              <p className="text-[#B91C1C] font-bold text-sm mt-3" data-id="element-274">
                Ya sabes cómo termina esa historia.
              </p>
            </div>
            <div className="bg-[#F0F4EC] border border-[#2D5A3D]/30 rounded-xl p-5" data-id="element-275">
              <p className="font-bold text-[#2D5A3D] text-sm uppercase tracking-wide mb-3" data-id="element-276">
                El Camino B
              </p>
              <p className="text-[#5C4A3A] text-sm leading-relaxed" data-id="element-277">
                Por menos de lo que cuesta una sola consulta médica, tienes el
                sistema completo que puede comenzar a transformar tu salud en
                las próximas{' '}
                <span className="font-bold text-[#2C1810]" data-id="element-278">72 horas.</span>
              </p>
              <p className="text-[#2D5A3D] font-bold text-sm mt-3" data-id="element-279">
                Tú decides.
              </p>
            </div>
          </div>

          {/* "No es normal" closing */}
          <div className="bg-white p-8 rounded-xl border border-[#E8DFD0] shadow-sm" data-id="element-280">
            <h4 className="text-[#2C1810] font-serif font-bold text-xl mb-4" data-id="element-281">
              Una Última Cosa...
            </h4>
            <p className="text-[#5C4A3A] mb-3 text-sm" data-id="element-282">
              Ahora mismo, mientras lees esto, tu cuerpo está enviando señales
              de socorro que has aprendido a ignorar.
            </p>
            <div className="space-y-1.5 mb-4" data-id="element-283">
              {['El cansancio no es "normal".', 'El dolor no es "inevitable".', 'La niebla mental no es "la edad".'].map((line, i) => <p key={i} className="font-bold text-[#2C1810] text-base" data-id="element-284">
                  {line}
                </p>)}
            </div>
            <p className="text-[#5C4A3A] text-sm mb-2" data-id="element-285">
              Son mensajes de un sistema que nunca tuvo las herramientas
              correctas.
            </p>
            <p className="font-bold text-[#2D5A3D] text-lg" data-id="element-286">
              Hoy, por $6.97, le das esas herramientas.
            </p>
          </div>
        </div>

        <OfferSection showUrgency={false} showCountdown={false} showGuarantee={false} showPayment={false} ctaText="SÍ — QUIERO RECUPERAR MI VITALIDAD AHORA →" data-id="element-287" />

        <div className="text-center mt-6 space-y-2" data-id="element-288">
          <p className="text-xs font-bold text-[#B91C1C] uppercase tracking-wide" data-id="element-289">
            Solo quedan 60 copias disponibles
          </p>
          <p className="text-xs text-[#5C4A3A] flex items-center justify-center gap-1.5" data-id="element-290">
            <Lock className="w-3 h-3 text-[#2D5A3D]" data-id="element-291" /> Tu compra está 100%
            protegida por nuestra Garantía de 7 Días Sin Riesgo
          </p>
        </div>

        {/* P.D. Postscript */}
        <div className="mt-10 border-t border-[#E8DFD0] pt-8" data-id="element-292">
          <div className="bg-[#FFFBEB] border border-[#C17817]/30 rounded-xl p-6 text-left" data-id="element-293">
            <p className="text-[#C17817] font-bold text-xs uppercase tracking-widest mb-3" data-id="element-294">
              P.D.
            </p>
            <p className="text-[#5C4A3A] text-sm leading-relaxed mb-3" data-id="element-295">
              Cada día que esperas es un día más de inflamación silenciosa. Tu
              cuerpo ya sabe lo que necesita. Ahora tú también lo sabes.
            </p>
            <p className="text-[#2C1810] font-bold text-base" data-id="element-296">
              La pregunta no es si puedes permitirte $6.97.{' '}
              <span className="text-[#B91C1C]" data-id="element-297">
                La pregunta es: ¿Puedes permitirte seguir sintiéndote así?
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}